import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';

@Component({
  selector: 'item-options',
  templateUrl: './item-options.component.html',
  styleUrls: ['./item-options.component.scss']
})
export class ItemOptionsComponent implements OnInit {
  @Input() options: Array<Object> = [];
  @Output() onClick = new EventEmitter();
  
  constructor() { }

  ngOnInit() {
  }

}
